// extracted by mini-css-extract-plugin
export default {"list":"BookingList_list__ljFVh","card":"BookingList_card__kQ8Hb","blank":"BookingList_blank__2TKBQ","spinner":"BookingList_spinner__4VpQ0"};